export default __webpack_public_path__ + "contentweb/app/pages/MRX/MRXPage/featured-image.f9594a10.png";